Core.AttestRouter = Core.SubRouter.extend({
    routes: {

        '': 'attest',
        'mine': 'mine',
        'all': 'all',
        'templates': 'templates',
        'user/:id': 'user',
        'customer/:id': 'customer',
        'customerproject/:id': 'customerProject',
        'order/:id': 'order',
        '*default': 'attest'
    },

    attest: function () {
        var view = new AttestListView({scrolling: true});
        view.fetchList('all');
        app.setMainView(view, 'attest', { wideContainer: true});
    },

    mine: function() {
        var view = new AttestListView({scrolling: true});
        view.selectList('mine');
        app.setMainView(view, 'attest', { wideContainer: true});
    },

    all: function() {
        var view = new AttestListView({scrolling: true});
        view.fetchList('all');
        app.setMainView(view, 'attest', { wideContainer: true});
    },

    templates: function() {
        var view = new AttestListView({scrolling: true});
        view.fetchList('templates');
        app.setMainView(view, 'attest', { wideContainer: true});
    },

    user: function(id) {
        var view = new AttestListView({scrolling: true});
        view.fetchList('user/'+id);
        app.setMainView(view, 'attest', { wideContainer: true});
    },

    customer: function(id) {
        var view = new AttestListView({scrolling: true});
        view.fetchList('customer/'+id);
        app.setMainView(view, 'attest', { wideContainer: true});
    },

    customerProject: function(id) {
        var view = new AttestListView({scrolling: true});
        view.fetchList('customerProject/'+id);
        app.setMainView(view, 'attest', { wideContainer: true});
    },

    order: function(id) {
        var view = new AttestListView({scrolling: true});
        view.fetchList('order/'+id);
        app.setMainView(view, 'attest', { wideContainer: true});
    },

});
